import classnames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp, IconPrefix } from '@fortawesome/fontawesome-svg-core'

import 'common/assets/icons'

export interface Props {
  iconName: string,
  active?: boolean,
  prefix?: IconPrefix,
  className?: string,
  ariaLabel?: string
}

const Icons = ({ className, ariaLabel, prefix, iconName, active }: Props) => {
  const iconConfig = (prefix ? { iconName, prefix } : iconName) as IconProp

  return (
    <FontAwesomeIcon
      aria-label={ariaLabel}
      className={classnames('fontawesome-icon', { 'fontawesome-icon-active': active }, className)}
      icon={iconConfig} />
  )
}

export default Icons
